import AWS from "aws-sdk";
import { cb2Promise, useGetAssumedKeysForBuildPureRole } from "../../common/AwsUtil";
import { FEATURE_PROJECT_DYNAMODB_TABLE, PROJECT_DYNAMODB_TABLE } from "../../common/env.constants";
import { useEffect, useState } from "react";

export function useCreateFeatureBranch(projectName, pipelineOwner) {
    const getAssumedKeys = useGetAssumedKeysForBuildPureRole();
    const [isCreating, setIsCreating] = useState(false);

    const createBranch = async (featureName, commitId) => {

        const params = await getAssumedKeys(pipelineOwner.toLowerCase());
        const dynamoDB = new AWS.DynamoDB(params);
        const codecommit = new AWS.CodeCommit(params);

        setIsCreating(true);

        return cb2Promise(codecommit, 'createBranch', {
            branchName: featureName,
            commitId: commitId,
            repositoryName: projectName
        }).catch((err) => {
            if (err.code !== 'BranchNameExistsException') throw err;
            else {
                console.log('Branch Exist, put dynamo DB directly: ', featureName);
            }
        }).then(() => {
            return cb2Promise(dynamoDB, 'query', {
                ExpressionAttributeValues: {
                    ':repository': { S: projectName },
                    ':feature': { S: featureName }
                },
                KeyConditionExpression: 'repositoryname = :repository AND featurename = :feature',
                TableName: FEATURE_PROJECT_DYNAMODB_TABLE
            });
        }).then(data => {
            if (data.Count > 0) {
                throw new Error("The pipeline already existed.")
            }
            return cb2Promise(dynamoDB, 'query', {
                ExpressionAttributeValues: {
                    ':repository': { S: projectName }
                },
                KeyConditionExpression: 'repositoryname = :repository',
                TableName: PROJECT_DYNAMODB_TABLE
            })
        }).then((data) => {
            const record = data.Items[0];

            if (!record.datalakeaccount) {
                record.datalakeaccount = { BOOL: false };
            }

            record.pipecreated = { BOOL: false };
            record.featurename = { S: featureName };
            record.markedfordeletion = { BOOL: false };

            return cb2Promise(dynamoDB, 'putItem', {
                Item: record,
                TableName: FEATURE_PROJECT_DYNAMODB_TABLE,
            });
        }).finally(() => {
            setIsCreating(false);
        });
    }

    return {
        isCreating,
        createBranch
    };
}

export function useFetchFeatureBranchs(isValid, projectName, pipelineOwner) {

    const getAssumedKeys = useGetAssumedKeysForBuildPureRole();
    const [ branchs, setBranchs] = useState([]);

    useEffect(() => {
        if (!isValid) return;
        const fetchBranchs = async () => {
            try {
                setBranchs([]);
                const dynamoDBParams = await getAssumedKeys(pipelineOwner.toLowerCase());
                const dynamoDB = new AWS.DynamoDB(dynamoDBParams);
                const data = await cb2Promise(dynamoDB, 'query', {
                    ExpressionAttributeValues: {
                        ':repository': { S: projectName }
                    },
                    KeyConditionExpression: 'repositoryname = :repository',
                    TableName: FEATURE_PROJECT_DYNAMODB_TABLE
                })
                setBranchs(data.Items);
            } catch (err) {
                console.error("Failed to fetch feature branchs:", err);
            }
        }

        if (projectName && pipelineOwner) {
            fetchBranchs();
        }
    }, [isValid, getAssumedKeys, projectName, pipelineOwner]);

    if (!isValid) {
        return null;
    }

    return {
        branchs
    };

}